import { render, staticRenderFns } from "./AssignDrawerDialog.vue?vue&type=template&id=45f65a8a"
import script from "./AssignDrawerDialog.vue?vue&type=script&lang=ts"
export * from "./AssignDrawerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports